<i18n src="@/locales/models/quality_inspect.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/components/views/packing_house/quality_control/process/export_quality_inspect_info.yml"
  lang="yaml"
></i18n>
<template>
  <div class="my-8" v-if="quality_inspect">
    <div class="panel">
      <div class="panel-header columns-2">
        <h3 class="panel-header-title">{{ $t("labels.title") }}</h3>
        <!-- <h3 class="text-right">
          <i class="fa-regular fa-info-circle fa-xl text-lime-500" @click.prevent="open = !open"></i>
        </h3> -->
      </div>

      <div class="panel-body" v-show="open">
        <div class="divide-y divide-gray-200">
          <div class="grid grid-cols-1 gap-y-8 gap-x-4 sm:grid-cols-2">
            <div class="sm:col-span-1">
              <dt class="label-data">
                {{ $t("model.quality_inspect.week") }}
              </dt>
              <dd class="content-data">
                {{ quality_inspect.week }}
              </dd>
            </div>

            <div class="sm:col-span-1">
              <dt class="label-data">
                {{ $t("model.quality_inspect.started_at") }}
              </dt>
              <dd class="content-data">
                {{
                  quality_inspect.started_at
                    ? dateFormatter(
                        quality_inspect.started_at,
                        "DD MMM hh:mm A",
                        "YYYY-MM-DDTHH:mm::ss"
                      )
                    : ""
                }}
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.quality_inspect.finished_at") }}
              </dt>
              <dd class="content-data">
                {{
                  quality_inspect.finished_at
                    ? dateFormatter(
                        quality_inspect.finished_at,
                        "DD MMM hh:mm A",
                        "YYYY-MM-DDTHH:mm::ss"
                      )
                    : ""
                }}
              </dd>
            </div>
            <div class="sm:col-span-2" v-if="quality_inspect.observations">
              <dt class="label-data">
                {{ $t("model.quality_inspect.observations") }}
              </dt>
              <dd class="content-data">
                {{ quality_inspect.observations }}
              </dd>
            </div>
          </div>
        </div>
      </div>

      <div class="panel-footer">
        <div class="panel-footer-actions">
          <destroy-button
            v-if="!proc_button_destroy"
            :disabled_button="false"
            @destroyEvent="destroyInspect()"
            :label="$t('labels.destroy_button_label')"
            :title="$t('labels.destroy_button_title')"
            :message="$t('labels.destroy_button_message')"
            :label_confirm="$t('labels.destroy_button_label_confirm')"
          />
          <destroy-button-processing
            v-else
            :label="$t('labels.destroy_button_label')"
          />
          <span class="space-actions"></span>
          <edit-button
            @click.prevent="goToEdit()"
            :label="$t('labels.edit_link')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "QualityInspectInfo",
  data: () => ({
    open: true,
    proc_button_destroy: false,
  }),
  props: {
    quality_inspect: {
      type: Object,
      required: true,
    },
    destroy: {},
    goToEdit: {},
  },
  methods: {
    destroyInspect: async function () {
      this.proc_button_destroy = true;
      await this.destroy()
      this.proc_button_destroy = false;
    },
    producerOrOrganizationLabel(exported_batch) {
      if (!exported_batch) return;
      let label = "";
      if (exported_batch.producer) label += exported_batch.producer.name;
      if (exported_batch.organization) {
        if (label) label += ` (${exported_batch.organization.name})`;
        else label += exported_batch.organization.name;
      }
      return label;
    },
  },
};
</script>
